import { Person, PersonName } from "domain";

export const initState = {
    list: [],
    isLoading: false,
    hasFailed: false
};

export default function personReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_PERSON_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LIST_PERSON_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LIST_PERSON_FULFILLED': {
            return {
                ...state,
                list: payload.map(item => new PersonName(item)),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'SAVE_PERSON_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'SAVE_PERSON_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'SAVE_PERSON_FULFILLED': {
            return {
                ...state,
                isLoading: false,
                hasFailed: false
            };
        }

        case 'SAVE_PERSON_EXPERTISE_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'SAVE_PERSON_EXPERTISE_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'SAVE_PERSON_EXPERTISE_FULFILLED': {
            return { ...state, isLoading: false, hasFailed: false };
        }

        default: {
            return state;
        }
    }
}